import {useAuthentication} from "../../features/Authentication/context";
import { getSubDomainFromDomain } from "../helpers/url";

export const useSubDomain = () => {
    const { domain, isMainDomain } = useAuthentication();
	return isMainDomain
		? (process.env.REACT_APP_MAIN_DOMAIN)
		: getSubDomainFromDomain(domain);
};
